import { useQuery } from '@tanstack/react-query'
import { fetchPaymentMethodStatus } from '../subscriptions'
import { paymentMethodStatusQueryKey } from './stripeBillingQueryKeys'

interface UsePaymentMethodStatusProps {
  slug: string
  enabled?: boolean
}

export const paymentMethodStatusQueryOptions = ({
  slug,
  enabled = true
}: UsePaymentMethodStatusProps) => ({
  queryKey: paymentMethodStatusQueryKey(slug),
  queryFn: () => fetchPaymentMethodStatus({ slug }),
  enabled: Boolean(slug) && enabled,
  staleTime: 6 * 60 * 60 * 1000, // 6h
  gcTime: 24 * 60 * 60 * 1000, // 24h
  refetchOnMount: false,
  refetchOnWindowFocus: false,
  refetchOnReconnect: false
})

export const usePaymentMethodStatus = ({ slug, enabled = true }: UsePaymentMethodStatusProps) =>
  useQuery(paymentMethodStatusQueryOptions({ slug, enabled }))

export { paymentMethodStatusQueryKey } from './stripeBillingQueryKeys'
